import Form from "../forms/form";
import {storage} from "../utils/storage";
import Data from "./Data";
import {urlEncoder} from "../utils/url";

export const giftCardsMixin = {
    mixins: [storage, urlEncoder],
    data: () => ({
        giftCards: new Data({
            url: '/gift-cards/list',
            prefix: 'list'
        }),
        form: new Form({
            'type_id': '',
            'email': '',
            'phone': '',
            'ecocash': '',
            'name': '',
            'payment': 'ecocash',
            'delivery': 'sms',
            'message': '',
        }),
    }),
    methods: {
        async getGiftCards(giftCardId) {
            this.giftCards.filters.id = giftCardId;
            await this.giftCards.fetch();
        },
        purchase() {
            this.saveToLocalStorage();
            return this.form.submit('/gift-cards/purchase').then(async response => {
                // Redirect based on payment type
                if (response.data.success) {
                    if (response.data.body.payment.payment === "ecocash") {
                        await this.$router.push(`/gift-cards/ecocash?id=${response.data.body.payment.ref}`);
                    }

                    if (response.data.body.payment.payment === "stripe") {
                        window.location.href = response.data.body.payment.url;
                    }
                }
            })
        },
        complete() {
            // return this.form.submit('/gift-cards/complete')
        }
    },
    async mounted() {
        this.initStorage([
            'email',
            'phone',
            'ecocash',
            'name',
            'payment',
        ], 'gift-cards');

        await this.getGiftCards(
            this.decode(this.$route.params.id)
        );
    }
}
